const BaseComponent = require('common/home-block/extend');
class investmentFormation extends BaseComponent {
  init () {
    super.init();
  }
}
module.exports = investmentFormation;
